import usePendingRecipients from './usePendingRecipients';

export { usePendingRecipients };
